import type { LandFormInput } from "web_myplann/Portfolio/Forms/LandForm/landFormSchema";

export const LAND_FORM_DEFAULT_VALUES: LandFormInput = {
	name: "",
	location: "",
	locationMunicipality: "",
	locationZipCode: "",
	parcelNumber: "",
	landSize: null,
	landValue: null,
	purchaseDate: null,
	description: "",
	forInvestments: false,
};
